import React from "react";
import "../estilos/slider.css";

export default function IconoSvg({nombre, icono, mensaje}) {
        return (
            <div className="icono-svg">
                <img //src={icono}
                    src={process.env.PUBLIC_URL + require(`../imagenes/iconos/${icono}.svg`)}
                    alt={"nombre"}/>
                <span className="nombre-svg">{nombre}</span>
                <span className="mensaje-svg">{mensaje}</span>

            </div>
        )
}

